"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRelatedPages = exports.getSearcherInfo = exports.initPagesSearchApiListener = exports.initAvSearchApiListener = exports.getFooterInfo = exports.getJsonFooter = exports.getHeaderInfo = exports.getJsonBySegment = void 0;
const effects_1 = require("redux-saga/effects");
const redux_saga_1 = require("redux-saga");
const next_app_controller_reducers_sagas_header_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.header-reducer");
const next_app_controller_reducers_sagas_main_reducer_n_1 = require("@gerenciatd/next.app-controller.reducers-sagas.main-reducer-n");
const next_utils_common_1 = require("@gerenciatd/next.utils.common");
const utils_1 = require("./utils");
const filePath = 'header-saga/index.js';
let DEVICE_MAX_RESULTS = 8;
let PAGES_MAX_RESULTS = 3;
let SERVICES_MAX_RESULTS = 4;
const ERROR_COLOR = '\x1b[31m%s\x1b[0m'; // red
const WARNING_COLOR = '\x1b[33m%s\x1b[0m'; // yellow
const INFO_COLOR = '\x1b[36m%s\x1b[0m'; // cyan
const SUCCESS_COLOR = '\x1b[32m%s\x1b[0m'; // green
const contextFromStore = (state) => state.main.context;
function* getJsonBySegment(segment) {
    let data = null;
    let context = yield (0, effects_1.select)(contextFromStore);
    /* Redefinimos el context en base a mi paradigma   */
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    const endpoint = currentEnv === 'qa'
        ? 'https://qa.cms.col.movistar.es'
        : 'https://prod.cms.col.movistar.es';
    context = Object.assign(Object.assign({}, context), { environment: {
            bucket: {
                headers: {},
                endpoint,
            },
        } });
    if (segment === 'gp') {
        const { getHeaderInfo: getHeaderInfoApi } = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('./promises/getHeaderInfoPromise'))));
        data = yield (0, effects_1.call)(getHeaderInfoApi, context);
    }
    else {
        const { getHeaderInfoEmp: getHeaderInfoEmpApi } = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('./promises/getHeaderInfoEmpPromise'))));
        data = yield (0, effects_1.call)(getHeaderInfoEmpApi, context);
    }
    return data;
}
exports.getJsonBySegment = getJsonBySegment;
function* getHeaderInfo({ data }) {
    const { pathname } = data;
    let jsonGpInfo = null;
    let jsonEmpInfo = null;
    try {
        jsonGpInfo = yield (0, effects_1.call)(getJsonBySegment, 'gp');
        jsonEmpInfo = yield (0, effects_1.call)(getJsonBySegment, 'emp');
    }
    catch (err) {
        console.log(WARNING_COLOR, 'No tenemos datos de cabecera, PROBABLEMENTE ESTAS EN VPN');
    }
    const finalSectionMenu = {};
    const finalSectionMenuEmp = {};
    const finalMovistarMenuInfo = {};
    const finalMovistarMenuInfoEmp = {};
    const location2useForRenderHeader = {
        host: 'movistar.es',
        pathname,
    };
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    if (jsonGpInfo) {
        /* public begins */
        const { sectionMenu: publicSectionMenu, movistarMenuInfo: publicMovistarMenuInfo, } = (0, utils_1.normalizerJsonInfo)({
            info: jsonGpInfo,
            location: location2useForRenderHeader,
        });
        finalSectionMenu.public = publicSectionMenu;
        finalMovistarMenuInfo.public = publicMovistarMenuInfo;
        /* public ends */
        /* telco */
        const { sectionMenu: telcoSectionMenu, movistarMenuInfo: telcoMovistarMenuInfo, } = (0, utils_1.normalizerJsonInfo)({
            info: jsonGpInfo,
            location: location2useForRenderHeader,
            userType: 'Telco',
        });
        finalSectionMenu.telco = telcoSectionMenu;
        finalMovistarMenuInfo.telco = telcoMovistarMenuInfo;
        /* legado */
        const { sectionMenu: legadoSectionMenu, movistarMenuInfo: legadoMovistarMenuInfo, } = (0, utils_1.normalizerJsonInfo)({
            info: jsonGpInfo,
            location: location2useForRenderHeader,
            userType: 'Legado',
        });
        finalSectionMenu.legado = legadoSectionMenu;
        finalMovistarMenuInfo.legado = legadoMovistarMenuInfo;
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_header_reducer_1.actions.setSectionMenu(finalSectionMenu));
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_header_reducer_1.actions.setMovistarMenu(finalMovistarMenuInfo));
    }
    if (jsonEmpInfo) {
        /* public begins */
        const { sectionMenu: publicSectionMenuEmp, movistarMenuInfo: publicMovistarMenuInfoEmp, } = (0, utils_1.normalizerJsonInfo)({
            info: jsonEmpInfo,
            location: location2useForRenderHeader,
        });
        finalSectionMenuEmp.public = publicSectionMenuEmp;
        finalMovistarMenuInfoEmp.public = publicMovistarMenuInfoEmp;
        /* public ends */
        /* telco */
        const { sectionMenu: telcoSectionMenuEmp, movistarMenuInfo: telcoMovistarMenuInfoEmp, } = (0, utils_1.normalizerJsonInfo)({
            info: jsonEmpInfo,
            location: location2useForRenderHeader,
            userType: 'Telco',
        });
        finalSectionMenuEmp.telco = telcoSectionMenuEmp;
        finalMovistarMenuInfoEmp.telco = telcoMovistarMenuInfoEmp;
        /* legado */
        const { sectionMenu: legadoSectionMenuEmp, movistarMenuInfo: legadoMovistarMenuInfoEmp, } = (0, utils_1.normalizerJsonInfo)({
            info: jsonEmpInfo,
            location: location2useForRenderHeader,
            userType: 'Legado',
        });
        finalSectionMenuEmp.legado = legadoSectionMenuEmp;
        finalMovistarMenuInfoEmp.legado = legadoMovistarMenuInfoEmp;
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_header_reducer_1.actions.setSectionMenuEmp(finalSectionMenuEmp));
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_header_reducer_1.actions.setMovistarMenuEmp(finalMovistarMenuInfoEmp));
    }
    yield (0, effects_1.put)(next_app_controller_reducers_sagas_header_reducer_1.actions.setHeaderLocation(location2useForRenderHeader));
    if ((!jsonGpInfo || !jsonEmpInfo) && currentEnv !== 'dev') {
        throw new Error('No tenemos datos de cabecera');
    }
}
exports.getHeaderInfo = getHeaderInfo;
function* getJsonFooter() {
    let data = null;
    let context = yield (0, effects_1.select)(contextFromStore);
    /* Redefinimos el context en base a mi paradigma */
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    const endpoint = currentEnv === 'qa'
        ? 'https://qa.cms.col.movistar.es'
        : 'https://prod.cms.col.movistar.es';
    context = Object.assign(Object.assign({}, context), { environment: {
            bucket: {
                headers: {},
                endpoint,
            },
        } });
    const { getJsonFooter: getFooterInfoApi } = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('./promises/getJsonFooterPromise'))));
    const gpInfo = yield (0, effects_1.call)(getFooterInfoApi, context);
    data = gpInfo;
    return data;
}
exports.getJsonFooter = getJsonFooter;
function* getFooterInfo({ data }) {
    let pathName = 'default';
    if (data && data.pathName) {
        ({ pathName } = data);
    }
    let jsonInfo = null;
    try {
        jsonInfo = yield (0, effects_1.call)(getJsonFooter);
    }
    catch (err) {
        console.log(WARNING_COLOR, 'No tenemos datos de footer, PROBABLEMENTE ESTAS EN VPN');
    }
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    if (jsonInfo) {
        const finalInfo = {
            about: Object.assign({}, jsonInfo.about[pathName]),
            links: Object.assign({}, jsonInfo.links[pathName]),
        };
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_header_reducer_1.actions.setFooterInfo(finalInfo));
    }
    if (!jsonInfo && currentEnv !== 'dev') {
        throw new Error('No tenemos datos del pie');
    }
}
exports.getFooterInfo = getFooterInfo;
// SEARCH ENGINE
const searchEngines = {
    pages: null,
    asistente: null,
};
const normalizerQuery = (queryStr) => {
    let res = queryStr.toLowerCase();
    res = res.replace(/á/g, 'a');
    res = res.replace(/é/g, 'e');
    res = res.replace(/í/g, 'i');
    res = res.replace(/ó/g, 'o');
    res = res.replace(/ú/g, 'u');
    return res;
};
let searchApi = null;
let Search = null;
function* createSearchEngine(info, props = {
    fieldNamesOrIndexFunction: [
        'name',
        'path',
        'brand',
        'storage',
        'category',
        'color',
        'normalizedName',
        'filter',
        'allProductsName'
    ],
    resourceName: 'pages',
}) {
    try {
        return (0, redux_saga_1.eventChannel)((emitter) => {
            const iv = 0;
            const { resourceName } = props;
            searchEngines[resourceName] = new searchApi.default({ Search });
            searchEngines[resourceName].indexResource(Object.assign(Object.assign({}, props), { resources: info }));
            searchEngines[resourceName].subscribe((data) => {
                emitter(data);
            }, (error) => { console.log(error); });
            // The subscriber must return an unsubscribe function, but it will never happen
            return () => {
                clearInterval(iv);
            };
        });
    }
    catch (error) {
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_n_1.actions.throwSonda({
            processName: 'createSearchEngine',
            filePath,
            error,
            kind: next_app_controller_reducers_sagas_main_reducer_n_1.SONDA_KIND.FATAL,
        }));
        console.log(error);
    }
}
function* initAvSearchApiListener(avList) {
    try {
        const chan = yield (0, effects_1.call)(createSearchEngine, avList, {
            fieldNamesOrIndexFunction: ['normalizedName'],
            resourceName: 'asistente'
        });
        while (true) {
            const info = yield (0, effects_1.take)(chan);
            const { result } = info;
            const querySuggestedInputs = result.slice(0, 3).map(item => {
                const newItem = {
                    label: item,
                    kind: 'av'
                };
                return newItem;
            });
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_header_reducer_1.actions.setSuggestedInputs({
                querySuggestedInputs: [...querySuggestedInputs]
            }));
            // hacemos la logica de suggested
            // yield call(getSuggestedInputs, query, categoriesMatched);
        }
    }
    catch (error) {
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_n_1.actions.throwSonda({
            processName: 'initAvSearchApiListener',
            filePath,
            error,
            kind: next_app_controller_reducers_sagas_main_reducer_n_1.SONDA_KIND.FATAL,
        }));
    }
}
exports.initAvSearchApiListener = initAvSearchApiListener;
function* initPagesSearchApiListener(pagesList) {
    try {
        const chan = yield (0, effects_1.call)(createSearchEngine, pagesList);
        while (true) {
            const info = yield (0, effects_1.take)(chan);
            const { result, text: query } = info;
            const pagesList = yield (0, effects_1.select)(state => state.header.pagesList);
            const categoryOptions = yield (0, effects_1.select)(state => state.header.categoryOptions);
            const categoriesMatched = [];
            const mappedResults = {
                devices: [],
                regular: [],
                services: [],
            };
            const device = (0, next_utils_common_1.getDeviceKindDependsOnViewPort)();
            if (device !== 'pc') {
                DEVICE_MAX_RESULTS = 6;
                PAGES_MAX_RESULTS = 2;
                SERVICES_MAX_RESULTS = 2;
            }
            // for clasico para limitar la busqueda
            let cndStop = false;
            for (let i = 0; (!cndStop && i < result.length); i++) {
                const itemFounded = result[i];
                const item = Object.assign({ key: itemFounded, pathName: itemFounded }, pagesList[itemFounded]);
                const isDevice = item && item.brand;
                const isService = item && item.products;
                let cndMaxDevice = mappedResults.devices.length < DEVICE_MAX_RESULTS;
                let cndMaxService = mappedResults.services.length < SERVICES_MAX_RESULTS;
                const cndMaxPages = mappedResults.regular.length < PAGES_MAX_RESULTS;
                if (isDevice) {
                    // almacenamos categoria encontrada
                    const deviceCategories = item.category && item.category ? item.category.split(',') : [];
                    if (deviceCategories && Array.isArray(deviceCategories)) {
                        deviceCategories.forEach(currentCategory => {
                            const noAlreadyPushed = categoriesMatched.find(category => category && (category.id === currentCategory));
                            if (!noAlreadyPushed) {
                                const existCategory = categoryOptions && categoryOptions[currentCategory];
                                if (existCategory) {
                                    categoriesMatched.push(existCategory);
                                }
                            }
                        });
                    }
                    // if(deviceCategories && deviceCategories[deviceCategories.length - 1]){
                    //   deviceKind = deviceCategories[deviceCategories.length - 1];
                    //   if(!categoriesMatched.find(category => category && (category.id===deviceKind))) {
                    //     categoriesMatched.push(categoryOptions[deviceKind]);
                    //   }
                    // }
                    // creamos elemente desde
                    if (cndMaxDevice && item.pvpRTRDesde) {
                        const currentItem = Object.assign(Object.assign({}, item), { key: `${item.key}.desde`, 'prePrice': 'Desde', 'unity': "€/mes", 'amount': item.pvpRTRDesde });
                        mappedResults.devices.push(currentItem);
                        cndMaxDevice = mappedResults.devices.length < DEVICE_MAX_RESULTS;
                    }
                    // creamos elemento por
                    if (cndMaxDevice && item.minPrice) {
                        const currentItem = Object.assign(Object.assign({}, item), { key: `${item.key}.min`, 'prePrice': 'Por', 'unity': "€", 'amount': item.minPrice });
                        mappedResults.devices.push(currentItem);
                        cndMaxDevice = mappedResults.devices.length < DEVICE_MAX_RESULTS;
                    }
                }
                else if (isService) {
                    if (item && item.products) {
                        item.products.forEach(product => {
                            if (cndMaxService) {
                                const smallItem = Object.assign(Object.assign({}, item), product);
                                smallItem.amount = smallItem.price;
                                delete smallItem.price;
                                delete smallItem.products;
                                const exist = mappedResults.services.findIndex(item => item.name === smallItem.name);
                                if (exist === -1) {
                                    mappedResults.services.push(smallItem);
                                    cndMaxService = mappedResults.services.length < SERVICES_MAX_RESULTS;
                                }
                            }
                        });
                    }
                }
                else if (cndMaxPages) {
                    mappedResults.regular.push(item);
                }
                // analizo si termino
                if (!cndMaxDevice && !cndMaxService && !cndMaxPages) {
                    cndStop = true;
                    break;
                }
            }
            // ordena las estructuras por precio
            mappedResults.devices.sort((itemA, itemB) => {
                const alphabetically = itemA.name - itemB.name;
                if (alphabetically !== 0) {
                    return alphabetically;
                }
                return parseInt(itemA.amount, 10) - parseInt(itemB.amount, 10);
            });
            mappedResults.services.sort((itemA, itemB) => {
                return parseInt(itemA.amount, 10) - parseInt(itemB.amount, 10);
            });
            // hariamos los put de results
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_header_reducer_1.actions.setRelatedPages({
                pagesList: mappedResults,
                categoriesMatched,
                inputQuery: query,
            }));
        }
    }
    catch (error) {
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_n_1.actions.throwSonda({
            processName: 'initPagesSearchApiListener',
            filePath,
            error,
            kind: next_app_controller_reducers_sagas_main_reducer_n_1.SONDA_KIND.FATAL,
        }));
    }
}
exports.initPagesSearchApiListener = initPagesSearchApiListener;
const makeUpCustomObjectsArray = (object) => {
    const res = [];
    Object.keys(object).forEach(key => {
        const item = object[key];
        const newItem = Object.assign({ path: key, id: key, normalizedName: item.name ? normalizerQuery(item.name) : '' }, item);
        if (item && item.category && item.category.indexOf('novedades') !== -1) {
            res.unshift(newItem);
        }
        else {
            res.push(newItem);
        }
    });
    return res;
};
const normalizeCategoryOptions = (categoryOptions) => {
    let res = {};
    Object.keys(categoryOptions).forEach(keyName => {
        const currentItem = categoryOptions[keyName];
        const { title: label, url: pathName } = currentItem;
        const newItem = {
            key: keyName,
            id: keyName,
            label,
            pathName,
            kind: 'page'
        };
        res[keyName] = newItem;
    });
    return res;
};
let allInfo = null;
function* getSearcherInfo() {
    // Trocear trycatch por peti
    try {
        let infoSearcher = null;
        // vemos si ya tenemos la info
        let pagesList = null;
        let categoryOptions = null;
        let pagesListMapped = null;
        let suggestedInputs = null;
        infoSearcher = {};
        // buscamos toda la info que necesitamos
        const context = yield (0, effects_1.select)(contextFromStore);
        const { pageSegment: segment } = context;
        if (!allInfo) {
            const infoNeeded = yield (0, effects_1.all)([
                (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('js-worker-search')))),
                (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('./search-api')))),
                (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('./promises/getAllSearchInfoPromise'))))
            ]);
            searchApi = infoNeeded[1];
            Search = infoNeeded[0].default;
            let getAllSearchInfo = infoNeeded[2];
            getAllSearchInfo = getAllSearchInfo.default;
            allInfo = yield (0, effects_1.call)(getAllSearchInfo, { segment: `${process.env.NEXT_PUBLIC_ENV_SEGMENT || 'particulares'}`, context });
            // ME QUEDO CON LOS DATOS
            if (allInfo && allInfo.av) {
                suggestedInputs = allInfo.av.map((item, index) => {
                    return {
                        key: index,
                        id: item,
                        normalizedName: normalizerQuery(item),
                    };
                });
            }
            if (allInfo && allInfo.categoryOptions) {
                categoryOptions = normalizeCategoryOptions(allInfo.categoryOptions);
            }
            if (allInfo && allInfo.paths) {
                pagesListMapped = allInfo.paths;
                pagesList = makeUpCustomObjectsArray(allInfo.paths);
            }
            // guardamos en session
            infoSearcher.pagesList = pagesListMapped;
            infoSearcher.suggestedInputs = suggestedInputs;
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_header_reducer_1.actions.setSearcherInfo({
                pagesList: infoSearcher.pagesList,
                suggestedInputs,
                categoryOptions,
            }));
            // inicializamos apis buscador de paginas => yield all
            // inicializo apis buscador de av
            yield (0, effects_1.all)([
                (0, effects_1.call)(initAvSearchApiListener, suggestedInputs),
                (0, effects_1.call)(initPagesSearchApiListener, pagesList),
            ]);
        }
    }
    catch (error) {
        console.log(error);
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_n_1.actions.throwSonda({
            processName: 'getSearcherInfo',
            filePath,
            error,
            kind: next_app_controller_reducers_sagas_main_reducer_n_1.SONDA_KIND.FATAL,
        }));
    }
}
exports.getSearcherInfo = getSearcherInfo;
// performn search
function* getRelatedPages({ query }) {
    try {
        const normalizedQuery = normalizerQuery(query);
        if (searchEngines && searchEngines['pages'] && searchEngines['asistente']) {
            searchEngines['pages'].performSearch('pages', normalizedQuery);
            searchEngines['asistente'].performSearch('asistente', normalizedQuery);
        }
    }
    catch (error) {
        console.log(error);
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_n_1.actions.throwSonda({
            processName: 'getRelatedPages',
            filePath,
            error,
            kind: next_app_controller_reducers_sagas_main_reducer_n_1.SONDA_KIND.FATAL,
        }));
    }
}
exports.getRelatedPages = getRelatedPages;
//# sourceMappingURL=index.js.map